import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/** Map route segments to human-readable labels */
const segmentLabels: Record<string, string> = {
  assets: 'Assets',
  documents: 'Documents',
  compliance: 'Compliance',
  amc: 'AMC Contracts',
  tasks: 'Tasks',
  notifications: 'Notifications',
  'audit-logs': 'Audit Logs',
  settings: 'Settings',
  categories: 'Categories',
  locations: 'Locations',
  workflows: 'Workflows',
  templates: 'Templates',
  auth: 'Auth',
  callback: 'Callback',
};

function formatSegment(segment: string): string {
  return segmentLabels[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Don't show breadcrumb on the root dashboard
  if (pathSegments.length === 0) {
    return (
      <div className="flex items-center gap-1 text-sm text-slate-600">
        <Home size={14} />
        <span className="font-medium text-slate-900">Dashboard</span>
      </div>
    );
  }

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm">
      <Link to="/" className="text-slate-500 hover:text-slate-700 transition-colors">
        <Home size={14} />
      </Link>

      {pathSegments.map((segment, index) => {
        const isLast = index === pathSegments.length - 1;
        const href = '/' + pathSegments.slice(0, index + 1).join('/');
        const label = formatSegment(segment);

        return (
          <span key={href} className="flex items-center gap-1">
            <ChevronRight size={12} className="text-slate-400" />
            {isLast ? (
              <span className="font-medium text-slate-900">{label}</span>
            ) : (
              <Link to={href} className="text-slate-500 hover:text-slate-700 transition-colors">
                {label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
